<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <material-card color="blue" title="Minha Conta" text="">
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-text-field label="Nome" v-model="user.name" disabled />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="user.email"
                    class="purple-input"
                    label="Email"
                    disabled
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="user.cpf"
                    label="CPF/CNPJ"
                    class="purple-input"
                    disabled=""
                  />
                </v-flex>

                <v-flex xs12 md3>
                  <v-text-field
                    v-model="user.ID_document"
                    label="Documento"
                    class="purple-input"
                    disabled
                  />
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    v-model="user.orgao_emissor"
                    label="Orgão Emissor"
                    class="purple-input"
                    disabled
                  />
                </v-flex>
                <!--
                <v-flex
                  xs12
                  md3
                >
                  <v-text-field
                    :v-model="user.date_of_birth"
                    label="Data de Nascimento"
                    class="purple-input"
                    disabled/>
                </v-flex>
                -->
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="user.gender"
                    label="sexo"
                    class="purple-input"
                    disabled=""
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="user.marital_status"
                    label="Estado Civil"
                    class="purple-input"
                    disabled=""
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="user.marital_type"
                    label="Regime de Bens"
                    class="purple-input"
                    disabled=""
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="user.nationality"
                    label="Nacionalidade"
                    class="purple-input"
                    disabled=""
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="user.phone"
                    label="Telefone"
                    class="purple-input"
                    mask="(##) # ####-####"
                    disabled=""
                  />
                </v-flex>
                <!--
                <v-flex xs12 md4>
                  <v-text-field
                    :v-model="user.created_at | formatarData"
                    label="Cliente desde"
                    class="purple-input"
                    disabled=""/>
                </v-flex>
                -->
                <!--
                <v-flex
                  xs12
                  text-xs-right
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                  >
                    Update Profile
                  </v-btn>
                </v-flex>
                -->
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex xs12 md4>
        <material-card class="v-card-profile">
          <v-avatar slot="offset" class="mx-auto d-block" size="130">
            <img :src="`./img/avatar/${user.gender}.png`" />
          </v-avatar>
          <v-card-text class="text-xs-center">
            <h6 class="category text-gray font-weight-thin mb-3">
              {{ user.email }}
            </h6>
            <h4 class="card-title font-weight-light">{{ user.name }}</h4>
            <p class="card-description font-weight-light">
              Economizo na minha conta de energia e ajudo o planeta utilizando
              de fontes renováveis de energia e baixo impacto ambiental.
            </p>
            <!--
            <v-btn
              color="success"
              round
              class="font-weight-light"
            >Follow</v-btn>
            -->
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user"]),
  },
  filters: {
    formatarData: function (value) {
      if (!value) return "";
      // value = value.toString()
      let timestamp = value; // firebase data
      let myDate = new Date(timestamp._seconds * 1000); // date object
      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
  },
};
</script>
